import { useState } from 'react'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { LinkExternal } from 'blaze-ui/icons'
import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { Search } from 'components/Templates/TemplatesModalV2/components/Search'
import { InstagramAccountCard } from './InstagramAccountCard'
import { MetaAdsInstagramSelectProps } from './Types'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'

export const MetaAdsInstagramSelect = (props: MetaAdsInstagramSelectProps) => {
  const { selectedAccountId, onSelectAccount, instagramAccounts } = props

  const openWindowSafely = useOpenWindowSafely()

  const [search, setSearch] = useState('')
  const filteredInstagramPages = instagramAccounts.filter((account) =>
    (account.name ?? account.additional_data?.username).toLowerCase().includes(search.toLowerCase()),
  )

  const handleLinkAdAccount = () => {
    openWindowSafely('https://business.facebook.com/')
  }

  return (
    <div className={Styles.selectContainer}>
      <div className={Styles.section}>
        <Text variant="secondary">
          Select the Instagram account you want to use to run your ads. Your profile name will be shown in the ads.
        </Text>
      </div>

      <div className={Styles.selectContentContainer}>
        <div className={Styles.searchContainer}>
          <Search onChange={setSearch} query={search} useCompactUI placeholder="Search your accounts..." />
        </div>

        {filteredInstagramPages.map((account) => (
          <InstagramAccountCard
            key={account.provider_id}
            account={account}
            isSelected={selectedAccountId === account.provider_id}
            onSelect={() => {
              onSelectAccount(account.provider_id)
            }}
          />
        ))}
      </div>

      <div className={Styles.section}>
        <Text variant="secondary">
          Don't see your Instagram account listed? Make sure you've linked your ad account with Blaze. If you still
          don't see it, you may need to get access to the account.
        </Text>
        <Button variant="tertiary" size="sm" onPress={handleLinkAdAccount} endIcon={LinkExternal}>
          Link Page to Blaze
        </Button>
      </div>
    </div>
  )
}
